export default "__VITE_ASSET__BXZDaYyw__"